// Local-calendar date helpers. Date-only strings ("YYYY-MM-DD") must be parsed
// as local midnight, never UTC, or they display one day early west of UTC.

const pad = (n: number) => String(n).padStart(2, "0");

export function toLocalIso(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function localTodayIso(): string {
  return toLocalIso(new Date());
}

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function parseDateOnly(s: string): Date {
  if (DATE_ONLY.test(s.slice(0, 10)) && (s.length === 10 || /^\d{4}-\d{2}-\d{2}T00:00:00(\.0+)?(Z|\+00(:?00)?)?$/.test(s))) {
    return new Date(`${s.slice(0, 10)}T00:00:00`);
  }
  return new Date(s);
}

export function fmtDateOnly(s: string | null | undefined, opts?: Intl.DateTimeFormatOptions): string {
  if (!s) return "—";
  return parseDateOnly(s).toLocaleDateString(undefined, opts);
}

export function addDaysIso(iso: string, n: number): string {
  const d = parseDateOnly(iso);
  d.setDate(d.getDate() + n);
  return toLocalIso(d);
}
